import { useEffect, useState } from "react";
import { Dimension } from "../TypesAndConstants/types";
import { isMobile } from "react-device-detect";
import { getWindowDimensions } from '../Context/SizingContext'

export const aspectToPixel = (
  aspect: number,
  dimensions: Dimension,
  isSquare?: boolean,
) => {
  const scale =  1.2;
  if (isSquare) {
    /* 40 is the menu bar */ 
    let size = Math.min( dimensions.height-40, dimensions.width ) * 0.8;
    return { width: size, height: size };
  } else {

    let isPortrait = isMobile && ( dimensions.height > dimensions.width ); 
    let _width = isPortrait ? dimensions.height : dimensions.width
    const height = _width / aspect / scale;
    const width = _width / scale;
    return { width, height };
  }
};

export const portraitToLandscape = (
  img: HTMLImageElement,
  dx: number,
  dy: number
) => {
  const tempCanvas = document.createElement("canvas");

  tempCanvas.width = img.height;
  tempCanvas.height = img.width;
  const tempCtx = tempCanvas.getContext("2d");

  (tempCtx as any).save();
  (tempCtx as any).translate(img.height / 2, img.width / 2);
  (tempCtx as any).rotate(-0.5 * Math.PI);
  tempCtx?.drawImage(
    img,
    0,
    0,
    img.width,
    img.height,
    -(img.width / 2),
    -(img.height / 2),
    img.width,
    img.height
  );
  (tempCtx as any).translate(-(img.height / 2), -(img.width / 2));
  (tempCtx as any).restore();
  return tempCanvas.toDataURL("png", 1);
};

export const LandscapeToPortrait = (img: HTMLImageElement) => {
  const tempCanvas = document.createElement("canvas");

  tempCanvas.width = img.height;
  tempCanvas.height = img.width;
  const tempCtx = tempCanvas.getContext("2d");

  (tempCtx as any).save();
  (tempCtx as any).translate(img.height / 2, img.width / 2);
  (tempCtx as any).rotate(0.5 * Math.PI);
  tempCtx?.drawImage(
    img,
    0,
    0,
    img.width,
    img.height,
    -(img.width / 2),
    -(img.height / 2),
    img.width,
    img.height
  );
  (tempCtx as any).translate(-(img.height / 2), -(img.width / 2));
  (tempCtx as any).restore();
  return tempCanvas.toDataURL("png", 1);
};


export const toHTMLImage = (
  url: string,
  cb: (img: HTMLImageElement) => void
) => {
  var image = new Image();
  image.onload = () => {
    cb(image);
  };
  image.src = url;
};


export const useCurrentDimensions = (
  aspect: number,
  constrainHeight: boolean,
  isPortrait: boolean
) => {
  let [newDimensions, setDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    let timeoutId: any = null;
    const resizeListener = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => setDimensions(getWindowDimensions()), 150);
    };
    window.addEventListener("resize", resizeListener);

    return () => {
      window.removeEventListener("resize", resizeListener);
    };
  }, []);

  // if (isMobile && !isPortrait) {
  //   return mobileLandScapeDims(aspect, newDimensions, constrainHeight);
  // }

  return aspectToPixel(aspect, newDimensions, constrainHeight);
};

// const mobileLandScapeDims = (
//   aspect: number,
//   dimensions: Dimension,
//   isSquare?: boolean
// ) => {
//   const height = (window.outerWidth * 0.55) / aspect;
//   const width = window.outerWidth * 0.55;
//   return { width, height };
// };
